import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import PropTypes from "prop-types";

import EnhancedTableHead from "./TableHead";
import EnhancedTableToolbar from "./TableToolBar";
import EnhancedTableFooter from "./TableFooter";
import spliter from "helper/digit-spliter";
import ImgContainer from "../Image";
import useSelected from "hooks/use-selected";

EnhancedTable.propTypes = {
  title: PropTypes.string,
  onDelete: PropTypes.func,
  onSubmit: PropTypes.func,
  filterDate: PropTypes.func,
  filterBread: PropTypes.func,
  addDiscount: PropTypes.bool,
  isDateFiltred: PropTypes.number,
  isBreadFiltred: PropTypes.number,
  click: PropTypes.func,
  fatcor: PropTypes.bool,
  factorInfo: PropTypes.object,
};

export default function EnhancedTable(props) {
  const { selectedItems, setSelectedItems } = useSelected();

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = props.rows.map((n) => n.name);
      setSelectedItems(newSelecteds);
      return;
    }
    setSelectedItems([]);
  };

  const handleClick = (event, name, id) => {
    const selectedIndex = selectedItems.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedItems, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedItems.slice(1));
    } else if (selectedIndex === selectedItems.length - 1) {
      newSelected = newSelected.concat(selectedItems.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedItems.slice(0, selectedIndex),
        selectedItems.slice(selectedIndex + 1)
      );
    }

    setSelectedItems(newSelected);
  };

  const isSelected = (id) => selectedItems.indexOf(id) !== -1;

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ width: "100%", mb: 2 }} elevation={3}>
        <EnhancedTableToolbar
          numSelected={selectedItems.length}
          title={props.title}
          onDelete={props.onDelete}
          onSubmit={() => props.onSubmit(selectedItems)}
          filterDate={props.filterDate}
          filterBread={props.filterBread}
          isDateFiltred={props.isDateFiltred}
          isBreadFiltred={props.isBreadFiltred}
          factor={props.factor}
          factorInfo={props.factorInfo}
          addProduct={props.addProduct}
          addDiscount={props.addDiscount}
          addUser={props.addUser}
          addAdmin={props.addAdmin}
          addBranch={props.addBranch}
          addQuestion={props.addQuestion}
          addHomeProduct={props.addHomeProduct}
          productsCategory={props.productsCategory}
          addProductsCategory={props.addProductsCategory}
          addProductsSubCategory={props.addProductsSubCategory}
          category_id={props.category_id}
          addProducts={props.addProducts}
          addServices={props.addServices}
          addServicesSubCategory={props.addServicesSubCategory}
          addArticles={props.addArticles}
          addArticlesCategory={props.addArticlesCategory}
          addEducation={props.addEducation}
          addEducationCategory={props.addEducationCategory}
          addRecords={props.addRecords}
          addRecordsSubCategory={props.addRecordsSubCategory}
          addWorkSamplesCategory={props.addWorkSamplesCategory}
          addWorkSample={props.addWorkSample}
        />
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="آمار سفارشات"
            size={props.factor ? "small" : "medium"}
          >
            <EnhancedTableHead
              numSelected={selectedItems.length}
              onSelectAllClick={handleSelectAllClick}
              rowCount={props.rows.length}
              isSelectable={props.isSelectable}
              headCells={props.headCells}
              onSubmitAll={props.onSubmitAll}
            />

            <TableBody>
              {props.rows.map((row, Rowindex) => {
                const isItemSelected = isSelected(row.id);
                const labelId = `enhanced-table-checkbox-${Rowindex}`;

                return (
                  <TableRow
                    hover
                    onClick={
                      props.isSelectable
                        ? (event) => handleClick(event, row.name, row.id)
                        : () => (props.click ? props.click(row.id) : null)
                    }
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={"t-row" + Rowindex + props.title}
                    selected={isItemSelected}
                    sx={{ cursor: props.click ? "pointer" : "default" }}
                  >
                    {props.isSelectable && (
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            "aria-labelledby": labelId,
                          }}
                        />
                      </TableCell>
                    )}

                    {Object.keys(row).map((key, index) => {
                      const content = {
                        id: (props.page - 1) * 10 + Rowindex + 1,
                        img: (
                          <ImgContainer
                            src={row[key]}
                            width={60}
                            isWeb
                            height={50}
                          />
                        ),
                        price: spliter(row[key]),
                        priceMulty: spliter(row[key]),
                        stock: spliter(row[key]),
                      };
                      return (
                        <TableCell
                          id={labelId}
                          scope="row"
                          key={index + props.title + key}
                        >
                          {content[key] ?? row[key]}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}

              {props.factor && (
                <EnhancedTableFooter factorInfo={props.factorInfo} />
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}
